import { Message } from './index';

const frenchMessages: Message = {
  resources: {
    contracts: {
      _error: "Erreur lors de l'ouverture du contrat",
      name: 'Contrat |||| Contrats',
      title: 'Contrat %{id} %{deceasedClientName}',
      funeral: 'Funérailles de',
      contact: 'Contact',
      print: {
        agreement: 'Contrat de Services Funéraire',
        to: 'À',
        prearrangement: 'Arrangements Préalables',
        gst: 'TPS',
        pst: 'TVQ',
        contractNumber: 'Nº Contrat',
        serviceNumber: 'Nº Service',
        date: 'Date',
        beneficiary: 'Bénéficiaire',
        name: 'Nom',
        birthdate: 'Date de naissance',
        address: 'Domicilié(e)',
        telephone: 'Téléphone',
        email: 'Courriel',
        buyer: 'Acheteur(se)',
        if_buyer_different: 'si différent du bénéficiaire',
        funeral_services: 'SERVICES FUNÉRAIRES',
        services_and_fees: 'SERVICES ET FRAIS D\’UTILISATION DES LIEUX',
        basic_fees_title: 'Conseils et soutien professionnels:',
        basic_fees_description: 'Les frais pour les services de base de nos directeurs funéraires, du personnel professionnel et du personnel général comprennent la disponibilité 24 heures sur 24, les réunions sur les arrangements funéraires, la coordination avec la famille, le clergé et le cimetière, tous les détails liés à la préparation et au dépôt de documents et d’avis gouvernementaux, la supervision du service funéraire et de l’inhumation, le soutien et les conseils en matière de suivi.',
        religious_services: 'SERVICES RELIGIEUX',
        halachic: 'Exigences halachiques',
        transportation_services: 'SERVICES DE TRANSPORT',
        total_a: 'TOTAL DES SERVICES A',
        goods: 'BIENS',
        total_b: 'TOTAL DES SERVICES B',
        total_c: 'TOTAL DES DÉCAISSEMENTS C',
        subtotal_a_b: 'SOUS-TOTAL (A+B)',
        cost_with_taxes: 'COÛTS AVEC LES TAXES (A+B)',
        total: 'TOTAL AVEC LES TAXES (A+B+C)',
        total_no_c: 'TOTAL AVEC LES TAXES (A+B)',
        disbursements: 'DÉCAISSEMENTS*',
        summary: 'SOMMAIRE',
        signature: 'Signature',
        initials: 'Initiales',
        print_name: 'Nom',
        see_back: 'VOIR VERSO',
        page1_disbursements: '*L’acheteur désigne par les présentes le vendeur comme son mandataire dans le cadre de l’acquisition des divers biens et services énumérés dans la section « Décaissements » ci-dessus et l’acheteur s’engage à rembourser au vendeur les montants payés par le vendeur en son nom.',
        page2_1: 'Le contrat constitue l’intégralité de l’entente entre le ou les acheteurs et Paperman & Sons Inc. (le « vendeur ») relativement à l’objet des présentes.',
        page2_2: 'S’il y a plus d’un acheteur, les acheteurs conviennent par les présentes d’agir solidairement (conjoints et solidaires) à l’égard de toutes les obligations découlant du contrat. Dans tous les cas, les acheteurs conviennent expressément d’être liés au paiement de tous les montants dus en vertu du contrat.',
        page2_3: 'S’il y a plus d’un acheteur, toutes les références aux présentes à un seul acheteur doivent être lues au pluriel et toutes les dispositions du contrat s’appliquent à tous les acheteurs.',
        page2_4: 'L’acheteur atteste par les présentes avoir l’autorité requise pour exprimer les souhaits concernant la nature des funérailles et la disposition du corps du défunt conformément à l’article 42 du Code civil du Québec. Sauf disposition contraire de la loi, l’acheteur accepte d’être pleinement responsable et tenu responsable de tout acte accompli par le vendeur suite aux instructions reçues d’un acheteur sans l’autorité appropriée. L’acheteur décharge expressément le vendeur de toute responsabilité pouvant découler d’une action entreprise par ceux qui ont l’autorité appropriée pour donner des instructions au vendeur.',
        page2_5: 'Le « TOTAL AVEC TAXES » est immédiatement payable en totalité à la signature du contrat. Tout montant impayé à échéance portera intérêt au taux de 1 % par mois ou 12 % par année.',
        page2_6: 'Le vendeur n’est tenu à aucune obligation tant que le montant total payable en vertu de l’article 5 du contrat n’est pas reçu par le vendeur.',
        page2_7: 'L’acheteur sera tenu responsable envers le vendeur de tous les débours de tiers payés ou contractés par le vendeur en relation avec les funérailles du défunt. S’il y a plus d’un acheteur, les acheteurs seront tenus solidairement (conjoints et solidaires) responsables envers le vendeur de tous les débours à engager par le vendeur dans le cadre des funérailles du défunt. Tous les débours de tiers sont sujets à modification. Tous les débours de tiers doivent être payés par l’acheteur (s) au moment des funérailles du défunt.',
        page2_8: 'Le vendeur n’est pas responsable du retard ou du défaut d’exécuter une quelconque obligation si ce retard ou ce défaut d’exécution de la totalité ou de l’une quelconque de ses obligations en vertu du contrat découle de causes indépendantes de sa volonté sans sa faute ou sa négligence, y compris, sans limitation, les cas de force majeure, la guerre (déclarée et non déclarée), les mouvements populaires, les révolutions, les blocus, les faits d’ennemis publics, les actes de terrorisme, les actes de gouvernement, les épidémies, les pandémies, les restrictions des garanties, les grèves, les débrayages, les ralentissements, les conflits de travail, les embargos, des conditions météorologiques particulièrement mauvaises, un approvisionnement peu fiable ou insuffisant en électricité ou d’autres services publics ou ressources, des retards de transport et des difficultés ou défaillances financières, y compris, sans s’y limiter, l’insolvabilité ou la faillite d’un fournisseur, d’un sous-consultant ou d’un sous-traitant important ou essentiel du vendeur.',
        page2_9: 'Au moment des funérailles, le vendeur peut, à sa discrétion, fournir des biens et services de remplacement de qualité égale ou supérieure, selon ce que détermine le vendeur à sa seule discrétion.',
        page2_10: 'L’acheteur a reçu une preuve écrite de la consultation informatisée du registre des contrats d’arrangements préalables de services funéraires par le vendeur. Dans cette mesure, l’acheteur a fourni au vendeur les informations nécessaires pour effectuer la recherche informatisée requise.',
        page2_11: 'Tous les montants exprimés dans le contrat sont en dollars canadiens, sauf disposition contraire des parties.',
        page2_12: 'Le contrat est régi par les lois de la province de Québec.',
        page2_13: 'The Buyer recognizes having been provided with a French version of the Contract. The Parties hereby express their intention to have the Contract and all other related documents drawn up in English.',
        page2_14: 'L’Acheteur reconnait avoir reçu une version du Contrat en français. Les Parties expriment par la présente leur intention de faire rédiger le Contrat et tous les autres documents y afférents en anglais.',

        page2_1_pn: 'Le contrat constitue l’intégralité de l’entente entre l’acheteur, le bénéficiaire et Paperman & Sons Inc. (le « vendeur ») relativement à l’objet des présentes',
        page2_2_pn: 'L’acheteur et le bénéficiaire conviennent par les présentes d’agir solidairement (conjointement et solidairement) à l’égard de toutes les obligations relatives au contrat. L’acheteur et le bénéficiaire s’engagent expressément, ainsi que leurs successions respectives, à payer toutes les sommes dues au titre du contrat.',
        page_2_PN_4: 'Le vendeur est par les présentes autorisé à diriger les funérailles du bénéficiaire. Conformément à l’article 42 du Code civil du Québec, le bénéficiaire exprime par les présentes son souhait que des funérailles soient tenues de la manière énoncée aux présentes. Il est entendu que le bénéficiaire souhaite que des funérailles soient tenues de la manière indiquée aux présentes avec les biens et les services faisant spécifiquement l’objet du contrat, ou des biens et services de meilleure qualité ou en plus grand nombre. Toute instruction reçue des héritiers, successeurs ou fiduciaires successoraux du bénéficiaire ayant pour effet de réduire, en qualité ou en nombre, les biens et services prévus au contrat, est contraire aux souhaits exprimés par le bénéficiaire et peut être ignorée par le vendeur.',
        page_2_PN_5: 'Le bénéficiaire pourra révoquer, résilier ou modifier les volontés exprimées aux présentes à tout moment de son vivant. Le bénéficiaire ou l’acheteur pourra résilier ou modifier le contrat à tout moment du vivant du bénéficiaire, sous réserve des modalités des présentes et des pénalités applicables prévues par la loi. Toutefois, après le décès du bénéficiaire, le bénéficiaire et l’acheteur conviennent expressément qu’aucune modification du contrat ne pourra avoir pour effet de réduire le montant total payable en vertu des présentes, sauf disposition contraire du contrat ou de la législation applicable. Si le contrat est révoqué, résilié ou modifié, une copie du contrat modifié doit être envoyée à la fois au bénéficiaire et à l’acheteur, ou selon le cas, à leurs héritiers, successeurs ou liquidateurs. Toute modification de contrat est réputée faire partie intégrante du contrat.',
        page2_6_pn: 'Le vendeur n’est tenu à aucune obligation tant que le montant total payable en vertu de l’article 6 du contrat n’a pas été reçu par le vendeur.',
        page_2_PN_8: 'Les décaissements à des tiers liés aux funérailles du bénéficiaire ne sont pas inclus dans le contrat et seront engagés et payables au moment des funérailles aux prix et taux d’imposition alors en vigueur. Ces décaissements seront payables par l’acheteur ou la succession du bénéficiaire, chacun étant solidairement (conjointement et solidairement) responsable de l’autre.',
        page_2_PN_9: 'Tous les montants de taxe sur les produits et services (« TPS ») et de taxe de vente du Québec (« TVQ ») perçus en vertu du contrat sont calculés en fonction des prix et des taux en vigueur au moment de la signature. Si, après la date du contrat, il y a un changement dans les biens ou services fournis, le coût des biens et services modifiés, plus la TPS et la TVQ perçues au moment du contrat, sera remboursé. Tous les biens et services faisant nouvellement l’objet du contrat seront facturés aux prix et aux taux de taxe en vigueur.',
        page_2_PN_10: 'Le vendeur s’engage à fournir des services funéraires au décès du bénéficiaire du contrat dans la mesure où le vendeur en est informé dans un délai suffisant.',
        page_2_PN_12: 'Au moment des funérailles, le vendeur peut, à sa discrétion, fournir des biens et services de remplacement de qualité égale ou supérieure, selon ce que détermine le vendeur à sa seule discrétion.',
        page_2_PN_13: 'Si le bénéficiaire, l’acheteur ou le tiers désigné pour recevoir une copie du contrat change d’adresse, le bénéficiaire ou l’acheteur devra en informer le vendeur dans un délai de dix (10) jours à compter de la prise de connaissance de ce changement.',
        page_2_PN_16: 'Le bénéficiaire et l’acheteur ont reçu une preuve écrite de la consultation informatisée du registre des contrats d’arrangements préalables de services funéraires par le vendeur. Dans cette mesure, le bénéficiaire ou l’acheteur a fourni au vendeur les informations nécessaires pour effectuer la recherche informatisée requise.',
        page_2_PN_18: 'Conformément à la Loi sur les arrangements préalables de services funéraires et de sépulture, le vendeur enverra une copie du contrat au tiers désigné par le bénéficiaire ci-dessous, sauf si le bénéficiaire donne des instructions contraires au vendeur dans le contrat.',
        designated_person: 'Nom Du Tiers Désigné',
        or: 'OU',
        page2_release: 'Le bénéficiaire libère le vendeur de l’obligation d’envoyer une copie du présent contrat à un tiers, déclarant que le bénéficiaire préfère que le vendeur s’abstienne de le faire.',
        page2_Dispense:
          'L’acheteur dispense le vendeur de l’obligation de transmettre copie de la présente convention à un tiers, déclarant qu’il préfère que le vendeur s’abstienne de ce faire.',
        page2_buyer: 'Acheteur(se) (signature obligatoire si dispense)',
        page3_header:
          'RENSEIGNEMENTS EXIGÉS PAR LA LOI SUR LES ARRANGEMENTS DE SERVICES FUNÉRAIRES ET DE SÉPULTURE',
        page3_1: 'Dans les dix (10) jours suivant la conclusion du contrat, le vendeur devra, sauf dérogation écrite de l’acheteur, envoyer une copie du contrat à une personne désignée par l’acheteur afin que ce dernier soit informé de l’existence du contrat.',
        page3_2a:
          'Le contrat peut être résilié de la manière suivante:',
        page3_2b:
          'Si le contrat a été sollicité, négocié ou conclu AILLEURS qu’à l’établissement du vendeur:',
        page3_2c:
          'A. Il pourra être résilié gratuitement et sans pénalité dans un délai de trente (30) jours à compter de la réception par l’acheteur de sa copie du contrat. L’annulation se fait de l’une de deux façons:',
        page3_2d:
          'i. en retournant au vendeur ou à son représentant, après l’avoir rempli et signé, le formulaire intitulé « Formulaire d’annulation » qui doit être joint à la copie du contrat;',
        page3_2e:
          'ii. en retournant au vendeur ou à son représentant un avis écrit indiquant son intention de résilier le contrat.',
        page3_2f:
          'B. Après le délai de trente (30) jours, le contrat pourra également être résilié moyennant une pénalité. Dans ce cas, l’acheteur recevra le capital indexé au coût de la vie, moins 10 % du prix des biens et services non fournis. L’annulation se fait par l’envoi d’un avis écrit au vendeur ou à son représentant de son intention de résilier le contrat.',
        page3_2g:
          'Si le contrat a été sollicité, négocié et conclu À l’établissement du vendeur:',
        page3_2h:
          'Il peut être résilié à tout moment moyennant une pénalité. Dans ce cas, l’acheteur recevra le capital indexé au coût de la vie, moins 10 % du prix des biens et services non fournis. L’annulation se fait par l’envoi d’un avis écrit au vendeur ou à son représentant de son intention de résilier le contrat.',
        page3_3a:
          'La perception des paiements ainsi que la fourniture de biens ou de services par le vendeur sont soumises aux règles suivantes:',
        page3_3b:
          'Si le contrat a été sollicité, négocié ou conclu AILLEURS qu’à l’établissement du vendeur:',
        page3_3c:
          'A. Le vendeur ne peut percevoir un paiement partiel ou complet avant l’expiration d’un délai de trente (30) jours à compter de la réception par l’acheteur de sa copie du contrat. De plus, il ne peut pas fournir de biens ou de services avant l’expiration de ce délai.',
        page3_3d:
          'B. Après la période de trente (30) jours, le vendeur peut percevoir les paiements et fournir des biens et des services.',
        page3_3e:
          'Si le contrat a été sollicité, négocié et conclu À l’établissement du vendeur:',
        page3_3f: 'Le vendeur peut percevoir les paiements au moment de la signature du contrat et peut également fournir des biens et des services.',
        page3_4:
          'Le vendeur doit, dans les 45 jours de l’encaissement, déposer en fidéicommis auprès d’un dépositaire (une banque, une caisse populaire, une société de fiducie ou une autre institution financière) tout montant qu’il perçoit en paiement total ou partiel d’un contrat, à l’exception d’un montant ne représentant pas plus de 10 % du prix des biens et services qui n’ont pas été fournis. Le vendeur n’est pas tenu de déposer un montant payé par l’acheteur pour des biens ou des services fournis avant l’expiration du délai de 45 jours.',
        page3_5:
          'Le dépositaire doit informer l’acheteur par écrit du montant et de la date du premier dépôt en fidéicommis effectué pour lui par le vendeur. Cet avis doit être envoyé à l’acheteur dans les 30 jours suivant ce premier dépôt.',
        page3_6:
          'Il est interdit au vendeur de stipuler dans un contrat une clause d’indexation ou toute autre clause destinée à lui permettre d’augmenter le prix des biens et services prévus au contrat.',
        page3_7:
          'Le vendeur doit mettre à la disposition du public, en tout temps et dans chacun de ses établissements, une liste à jour du prix de chaque bien et de chaque service qu’il offre.',
        governed_pn:
          'Le présent contrat est régi par la Loi sur les arrangements préalables de services funéraires et de sépulture (chapitre A-23.001).',
        page3_box1:
          'Renseignements exigés en vertu de la Loi sur les arrangements de services funéraires et de sépulture',
        page3_box2:
          'Le présent contrat contient l’expression de la volonté du bénéficiaire concernant la nature des funérailles du bénéficiaire ou la disposition du corps du bénéficiaire, ou les deux. Une mention de l’existence du contrat sera inscrite dans le registre des contrats d’arrangements préalables de services funéraires et des contrats d’achat préalable de sépulture.',
        page3_box3:
          'Dans certaines circonstances, le bénéficiaire, l’acheteur et leurs héritiers, successeurs ou liquidateurs, peuvent modifier ou résilier le présent contrat selon les conditions prévues par les lois et règlements en vigueur. Si le bénéficiaire, l’acheteur ou leurs héritiers, successeurs ou liquidateurs résilient le présent contrat, les montants que le vendeur détient en fiducie conformément à la loi seront remis à l’acheteur, selon le cas, sous réserve de la pénalité que le vendeur peut imposer.',
        information_required_by_the_act: 'RENSEIGNEMENTS EXIGÉS PAR LA LOI SUR LES ARRANGEMENTS DE SERVICES FUNÉRAIRES ET DE SÉPULTURE',
          seller_must_make: 'Le vendeur doit mettre à la disposition du public, en tout temps et dans chacun de ses établissements, une liste à jour du prix de chaque bien et de chaque service qu’il offre.',
      
          buyer_name: 'Nom d\'acheteur(se)',
        buyer_signature: 'Signature d\'acheteur(se)',
        purchaser_address: 'Domicilié(e) d’acheteur(se)',
        seller_name: 'Nom du vendeur(se)',
        seller_signature: 'Signature du vendeur(se)',
        signed_in: 'Adresse où signé',
        page4_header: 'FORMULAIRE D’ANNULATION',
        page4_subheader: '(Loi sur les arrangements de services funéraires et de sépulture, art. 5)',
        cancellation1: 'Conformément au premier alinéa de l’article 10 de la Loi sur les arrangements de services funéraires et de sépulture, j’annule le contrat portant le numéro ',
        contract_number: '(numéro de contrat)',
        cancellation2: ', conclu le ',
        date_conclusion: 'Date à laquelle le contrat a été conclu',
        at: 'à',
        place_conclusion: 'Endroit où le contrat a été conclu',
        beneficiary_name: 'Nom du bénéficiaire',
        beneficiary_signature: 'Signature du bénéficiaire',
        beneficiary_address: 'Adresse du bénéficiaire',
        signed_outside: 'Si le Contrat est signé en dehors de l\'établissement du Vendeur',
        seller_name_outside: 'Nom du représentant du vendeur',
        seller_address_outside: 'Adresse du représentant du vendeur',
        buyer_or_beneficiary_name: 'Nom de l’acheteur ou du bénéficiaire',
        buyer_or_beneficiary_signature: 'Signature de l’acheteur ou du bénéficiaire',
        buyer_or_beneficiary_address: 'Adresse de l’acheteur ou du bénéficiaire',
        casket: 'CERCUEIL',
        religious_goods: 'BIENS RELIGIEUX',
        deceased: 'Défunt',
      },
      fields: {
        id: 'ID',
        service_id: 'Service ID',
        deceased_client_id: 'Personne décédée',
        description: 'Description',
        issue_date: 'Date',
        client_id: 'Client',
        memo: 'Memo',
        created_at: 'Crée',
        total_amount: 'Montant total',
        category: 'Catégorie',
        item: 'Item',
        price: 'Prix unititaire',
        quantity: 'Quantité',
        provincial_tax: 'Taxe provinciale',
        federal_tax: 'Taxe fédérale',
        tax: 'Taxe',
        total: 'Total',
        subTotal: 'Sous-total',
        signed_contract: 'Contrat signé',
      },
      lines: {
        name: 'Services et produits',
      },
      search: {
        client: 'Client',
        deceased_client: 'Client décédé',
      },
      tabs: {
        payments: 'Paiements',
      },
    },
    clients: {
      name: 'Client |||| Clients',
      title: 'Client %{id} %{name}',
      fields: {
        id: 'ID',
        name: 'Nom',
        address: 'Adresse',
        address2: 'Adresse 2',
        city: 'Ville',
        postal_code: 'Code postal',
        province: 'Province',
        email: 'Email',
        birthdate: 'Date de naissance',
        phone_number: 'Numéro de téléphone',
      },
      search: {
        name: 'Recherche par nom',
      },
    },
    categories: {
      name: 'Catégorie |||| Catégories',
      title: 'Catégorie %{id} %{name}',
      fields: {
        name: 'Nom',
        taxable: 'Taxable',
      },
    },
    items: {
      name: 'Article |||| Articles',
      title: 'Item %{id} %{name}',
      fields: {
        category: 'Catégorie',
        Name: 'Nom',
        Description: 'Description',
        UnitPrice: 'Prix',
        Active: 'Actif',
        IncomeAccount: 'Compte de revenu',
        ExpenseAccount: 'Compte de dépenses',
        Type: 'Type',
        Taxable: 'Taxable',
      },
      types: {
        category: 'Catégorie',
        inventory: 'Inventorié',
        nonInventory: 'Non-inventorié',
        service: 'Service',
      },
    },
    invoices: {
      name: 'Facture |||| Factures',
      pdf: 'Afficher le Pdf de la facture',
      pdf_success:
        'Ouverture du pdf de la facture Quickbooks dans un nouvel onglet',
      pdf_error:
        'Erreur lors de la récupération du pdf de la facture Quickbooks',
      fields: {
        TxnDate: "Date d'émission",
        DueDate: "date d'échéance",
        send_date: "Date d'envoie",
        Balance: 'Restant dû',
        TotalAmt: 'Montant total',
        PrintStatus: "Status d'impréssion",
        EmailStatus: 'Status email',
        GlobalTaxCalculation: 'Taxe globale calculée',
      },
      print: {
        invoice: 'FACTURE',
        invoice_number: 'No Facture',
        invoice_date: 'Date Facture',
        service: 'Service',
        service_number: 'No Service',
        interest: 'INTÉRÊTS',
        monthly_interest: 'Intérêts Mensuel',
        bill_to: 'Facturer à',
        terms: 'TERMES ET CONDITIONS',
        terms_details:
          'LE PAIEMENT EST DÛ IMMÉDIATEMENT À LA SIGNATURE DU CONTRAT. TOUTE SOMME IMPAYÉE À L\'ÉCHÉANCE PORTERA INTÉRÊT AU TAUX DE 1 % PAR MOIS OU 12 % PAR ANNÉE.',
        invoice_subtotal: 'SOUS-TOTAL',
        invoice_total: 'TOTAL',
        paid: 'PAYÉ',
        amount_due: 'MONTANT DÛ',
        category: 'CATÉGORIE',
        amount: 'MONTANT',
        Casket: 'Cercueil',
        Disbursements: 'Décaissements',
        "Funeral Services": 'Services Funéraires',
        "Religious Services": 'Services Religieux',
        "Religious Goods": 'Biens Religieux',
        Transportation: "Transport"
      },
      invoice_created: 'Facture crée',
      add: 'Ajouter une facture',
    },
    payments: {
      name: 'Paiement |||| Paiements',
      buttonAdd: 'Ajouter un paiement',
      methods: {
        credit_card: 'Carte de crédit',
        cheque: 'Chèque',
        etransfer: 'Virement Interac (E-Transfer)',
        cash: 'Espèces',
        wire: 'Virement bancaire',
        other: 'Autre',
      },
      fields: {
        created_at: 'Crée le',
        amount: 'Montant',
        method: 'Méthode',
        reference: 'Référence',
        payment_date: 'Date de paiement',
        payer: 'Payeur',
        note: 'Note',
      },
      created: 'Paiement crée',
    },
    funerals: {
      director: 'Directeur',
      missingDataSms: {
        title: 'Demander les informations manquantes par SMS',
        copyButton: 'Copier le message',
        copiedSuccess: 'Message copié dans le presse-papiers',
        copiedError: 'Erreur lors de la copie du message',
        allFieldsComplete: 'Tous les champs sont complets - aucun message nécessaire',
        recipient: 'Destinataire',
        phone: 'Téléphone',
        missingFields: '%{dec} champs DEC, %{benefits} champs Prestations manquants',
        loadingMessage: 'Chargement du message...',
        errorLoading: 'Erreur lors du chargement du message',
      },
      fieldGroups: {
        client: 'Client',
        basicInfo: 'Informations de base',
        funeralInfo: 'Informations sur la funéraille',
        shivaInfo: "Informations sur la Shiv'ah",
        additionalInfo: 'Informations complémentaires',
      },
    },
  },
  utils: {
    english_language: 'Anglais',
    french_language: 'Français',
    show: 'Voir',
    information: 'Information générale',
  },
  login: {
    title: "S'il-vous-plaît, connectez-vous pour continuer",
    button: 'Se connecter avec un compte Google',
    failed: 'Connexion échouée',
    loginSuccessful: 'Connexion réussie',
  },
};

export default frenchMessages;